import { Button } from '@opendoor/atoms/button';
import { cn } from '@opendoor/atoms/utils';
import type { useTouring } from 'components/self-tour/hooks/useTouring';

export type TourAction = NonNullable<ReturnType<typeof useTouring>>['primaryAction'];

export const TourActionButton = ({
  action,
  label = action.text,
  variant = action.variant,
  className,
}: {
  action: TourAction;
  label?: string;
  variant?: TourAction['variant'];
  className?: string;
}) => (
  <Button
    analyticsName={action.analyticsName}
    data-analytics-name={action.analyticsName}
    aria-label={label}
    variant={variant}
    size="md"
    onClick={action.onClick}
    disabled={action.disabled}
    href={action.disabled ? undefined : action.href}
    target={action.target}
    rel="noopener"
    className={cn(
      'w-full min-w-0 whitespace-nowrap rounded-xl px-2 text-label-sm transition-none not-disabled:active:scale-100',
      className,
    )}
  >
    {label}
  </Button>
);
